import { useCallback } from 'react';

const useSetCssVariable = (layoutRef?: React.RefObject<HTMLDivElement | null>) => {
  const setCssVariable = useCallback(
    (name: string, value: string) => {
      if (layoutRef?.current) layoutRef.current.style.setProperty(name, value);
    },
    [layoutRef]
  );

  const setHeightCssVariableForRef = useCallback(
    (name: string, ref?: React.RefObject<HTMLElement | null>) => {
      if (ref?.current)
        setCssVariable(name, `${ref.current.getBoundingClientRect().height || 0}px`);
    },
    [setCssVariable]
  );

  return { setCssVariable, setHeightCssVariableForRef };
};

export default useSetCssVariable;
